// validationService.js
import { apiClient } from '../api/ApiClient';

export const validateUsername = async (username) => {
  try {
    const response = await apiClient.get(`/rest/validate/username/${username}`);
    return response.data;
  } catch (error) {
    console.error('Username validation error:', error);
    throw error;
  }
};

export const validateEmail = async (email) => {
  try {
    const response = await apiClient.get(`/rest/validate/email/${email}`);
    return response.data;
  } catch (error) {
    console.error('Email validation error:', error);
    throw error;
  }
};

// Updated validateZipcode function in validationService.js
export const validateZipcode = async (zipcode) => {
  try {
    const response = await apiClient.get(`/rest/validate/zipcode/${zipcode}`);
    
    // Make sure the response is properly formatted for the frontend
    // This handles both possible property naming conventions
    return {
      valid: response.data && response.data.valid,
      // Include both property naming conventions for flexibility
      ZIP_CITYNAME: response.data.ZIP_CITYNAME,
      ZIP_STATEABBR: response.data.ZIP_STATEABBR,
      // Also include simplified property names
      city: response.data.ZIP_CITYNAME || response.data.city,
      state: response.data.ZIP_STATEABBR || response.data.state,
      message: response.data.valid ? '' : (response.data.message || 'Invalid zipcode')
    };
  } catch (error) {
    console.error('Zipcode validation error:', error);
    throw error;
  }
};